import React from 'react';
import { Wallet, Network, CheckCircle, FileSignature } from 'lucide-react';
import { colors, spacing, typography } from '../../../../tokens';

interface ConnectionStepsProps {
  currentStep: number;
}

/**
 * Visual progress indicator showing connection steps
 * Steps: 1=Connect Wallet, 2=Switch Network, 3=Sign Message, 4=Ready
 */
export const ConnectionSteps: React.FC<ConnectionStepsProps> = ({ currentStep }) => {
  const steps = [
    { number: 1, label: 'Connect Wallet', icon: Wallet },
    { number: 2, label: 'Switch Network', icon: Network },
    { number: 3, label: 'Sign Message', icon: FileSignature },
    { number: 4, label: 'Ready to Bridge', icon: CheckCircle },
  ];

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: spacing.md,
        marginBottom: spacing.xl,
        padding: spacing.lg,
        backgroundColor: colors.background.secondary.default,
        borderRadius: '12px',
      }}
    >
      {steps.map((step, index) => {
        const isActive = step.number === currentStep;
        const isCompleted = step.number < currentStep;
        const Icon = step.icon;

        return (
          <React.Fragment key={step.number}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: spacing.xs,
              }}
            >
              <div
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: isCompleted
                    ? colors.semantic.success
                    : isActive
                    ? colors.brand.primary.base
                    : colors.background.primary.default,
                  border: `2px solid ${
                    isCompleted
                      ? colors.semantic.success
                      : isActive
                      ? colors.brand.primary.base
                      : colors.border.default.default
                  }`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s ease',
                }}
              >
                <Icon
                  size={24}
                  color={
                    isCompleted || isActive
                      ? colors.text.primary.default
                      : colors.text.muted.default
                  }
                />
              </div>
              <div
                style={{
                  fontSize: typography.fontSize.xs,
                  color: isActive
                    ? colors.text.primary.default
                    : isCompleted
                    ? colors.text.secondary.default
                    : colors.text.muted.default,
                  fontWeight: isActive ? typography.fontWeight.semibold : typography.fontWeight.normal,
                  textAlign: 'center',
                }}
              >
                {step.label}
              </div>
            </div>

            {index < steps.length - 1 && (
              <div
                style={{
                  width: '40px',
                  height: '2px',
                  backgroundColor:
                    step.number < currentStep
                      ? colors.semantic.success
                      : colors.border.default.default,
                  transition: 'all 0.3s ease',
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
